<template>
    <div class="add-ref-cover-panel">
        <SelectItem v-if="selectShowing" class="add-ref-cover-select-item" :item-data="itemData" @itemSelect="selectItemType" />
        <CoverPanel
            v-else
            class="add-ref-cover-image-upload"
            :no-cover-icon="noCoverIcon"
            :image-url="innerImageUrl"
            :operate-icons="operateIcons"
            :view-icon="viewIcon"
            ishorizontal="ishorizontal"
            @uploadCover="uploadCover"
            @operatorSelect="operatorSelect"
            @viewClick="viewClick"
        />
        <span v-if="cancelShow" class="add-ref-cover-imge-cancel">
            <i class="el-icon-close" @click="imageCancel" />
        </span>
    </div>
</template>

<script>
import CoverPanel from "./CoverPanel.vue";
import SelectItem from "./SelectItem.vue";
import { widgetPermitByVlink } from "@/views/zhiji/js/common/util";

export default {
    name: "AddRefCoverPanel",
    components: {
        CoverPanel,
        SelectItem
    },
    props: ["noCoverIcon", "operateIcons", "imageUrl", "viewIcon", "ishorizontal", "needClip", "aspectRatio", "alwayShowCancel"],
    data() {
        return {
            seletImageType: "", // 图片上传类型
            innerImageUrl: this.imageUrl,
            selectShowing: !this.imageUrl
        };
    },
    computed: {
        cancelShow() {
            return this.alwayShowCancel || (!!this.innerImageUrl && this.selectShowing);
        },
        itemData() {
            const data = [
                {
                    type: "create",
                    position: "-198px -50px",
                    name: this.$t("zhiji.answer.uploadpic")
                }
            ];
            // vlink下 没有图片库的业务没有权限不显示引用
            const hasReferencePermit = widgetPermitByVlink(this.$store.state.gameState, "knowledge.pictures");
            if (hasReferencePermit) {
                data.unshift({
                    type: "reference",
                    position: "-383px -1px",
                    name: this.$t("zhiji.answer.reference"),
                    iconClass: "reference-icon"
                });
            }
            return data;
        }
    },
    watch: {
        imageUrl(newVal) {
            this.innerImageUrl = newVal;
        }
    },
    methods: {
        imageCancel() {
            this.selectShowing = false;
            this.$emit("cancel");
        },
        uploadCover(refImage) {
            this.uploadImage(refImage, imageUrl => {
                this.innerImageUrl = imageUrl;
                this.selectShowing = false;
                this.$emit("change", { value: imageUrl });
            });
        },
        operatorSelect(type) {
            if (type === "update") {
                this.selectShowing = true;
            } else {
                this.$emit("operatorSelect", type);
            }
        },
        uploadImage(refImage, cb) {
            this.$store.dispatch("zhiji/showModal", {
                type: "ImageClipModal",
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: url => {
                        cb && cb(url);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    imageUrl: refImage || "",
                    title: this.imageTitle || "",
                    needClip: this.needClip,
                    aspectRatio: this.aspectRatio
                }
            });
            // 打开组件时弹出文件选择，只有在isTrusted事件里面可以触发, HACK
            setTimeout(() => {
                if (this.openFile) {
                    this.openFile();
                }
                this.openFile = null;
            }, 500);
        },
        selectItemType(item) {
            const handler = {
                reference: this.referenceEdit,
                create: this.manualEdit
            };
            handler[item.type].call(null);
            this.seletImageType = item.type;
        },
        referenceEdit() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "image",
                    isSingle: true,
                    confirm: result => {
                        this.innerImageUrl = result[0].url;
                        this.imageTitle = result[0].title;

                        if (this.needClip) {
                            setTimeout(() => {
                                this.uploadCover(this.innerImageUrl);
                            }, 50);
                        } else {
                            this.$emit("change", { value: this.innerImageUrl });
                            this.selectShowing = false;
                        }
                    }
                }
            });
        },
        manualEdit() {
            this.uploadCover();
        },
        viewClick() {
            this.$emit("viewClick");
        }
    }
};
</script>

<style lang="less" scoped>
.add-ref-cover-panel {
    width: 142px;
    height: 107px;
    border: 1px solid #d8e4f0;
    position: relative;

    .add-ref-cover-select-item {
        width: 100%;
        height: 100%;
    }
    .add-ref-cover-image-upload {
        width: 100%;
        height: 100%;
        background: #fafbfd;
        border-radius: 4px;
        /deep/ .cover-image-panel {
            border-radius: 4px;
            overflow: hidden;
            & > img {
                max-width: none;
            }
        }
    }
    .add-ref-cover-imge-cancel {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #eee;
        position: relative;
        text-align: center;
        line-height: 34px;
        position: absolute;
        top: -15px;
        right: -15px;
        z-index: 9;
        .el-icon-close {
            font-size: 20px;
            font-weight: 700;
            color: #949494;
        }
    }
}
</style>
